<template>
  <div class="user-message-wraper-ym">
    <van-nav-bar 
      title="消息详情" 
      left-arrow 
      @click-left="$router.go(-1)"
    />
    <!-- 详情 -->
    <div class="msg-title">{{messageDetail.msgTitle}}</div>
    <div class="msg-time">{{messageDetail.sendUserName}}  {{messageDetail.sendTime}}</div>
    <div class="msg-content">{{messageDetail.msgContent}}</div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'userMessageDetail',
    data() {
      return {
        messageDetail: {},
      }
    },
    created() {
      this.id = this.$route.query.id 
      this.status = this.$route.query.status
    },
    mounted() {
      if(!this.status) {
        this.readOne()
      }
      this.getDetail()
    },
    methods:{
      // 已读
      async readOne() {
        await this.$api.userMessage.readOne({id: this.id})
      },
      // 消息详情
      async getDetail() {
        let result = await this.$api.userMessage.getDetail({id: this.id})
        if(result.success) {
          this.messageDetail = result.data
        }
      }
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
.user-message-wraper-ym
  .van-hairline--bottom::after
    border-color #fff
</style>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.ellipsis
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
.user-message-wraper-ym
  width 100%
  box-sizing border-box
  .msg-title
    font-size: 34px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 34px;
    padding 40px 30px 0
    width 100%
    box-sizing border-box
    word-wrap:break-word
  .msg-time 
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 26px;
    padding 30px 0
    margin 0 30px
    border-bottom 1px solid #E4E4E4
  .msg-content 
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 43px;
    padding 30px
    width 100%
    box-sizing border-box
    word-wrap:break-word

 
</style>
